import { moduleColors } from '../data/studyData';

export const ModuleLegend = () => {
  return (
    <div 
      className="flex flex-wrap gap-4 items-center"
      data-testid="module-legend"
      aria-label="Module color legend"
    >
      {Object.entries(moduleColors).map(([key, module]) => (
        <div 
          key={key}
          className="flex items-center gap-2"
          data-testid={`legend-${key.toLowerCase()}`}
        >
          <div className={`w-3 h-3 rounded-full ${module.indicator}`} />
          <span className="text-sm font-medium text-muted-foreground">
            {key === 'Both' ? 'Both' : key}
          </span>
        </div>
      ))}
    </div>
  );
};
